import type { RouteLocation } from "vue-router";

export default (route: RouteLocation, paramKey: string, index = 0) => {
  const param = route.params[paramKey];

  // this should not happen, but it provides us with type safety
  if (Array.isArray(param)) {
    return param[index];
  }

  return param;
};
